import { Simulation } from 'src/app/core/models/simulation.model';
import { Color, Mesh } from 'three';
import { Catenary3D } from '../../catenary-answer';
import { Floating } from '../../floating.model';
import { FloatingBuilder } from '../object-builders/floating-builder.model';
import GraphicProperties from './graphic-properties.model';

export class FloatingGraphicProperties extends GraphicProperties {
  color: Color;

  constructor({ color = new Color(0xffffff) } = {}) {
    super();
    this.color = color;
  }

  updateColor(color: Color): void {}

  async build(riser: Catenary3D, simulation: Simulation, connection: Floating): Promise<Mesh> {
    this.object = await this.getBuilder().build(riser, simulation, connection);
    return this.object;
  }

  getBuilder(): FloatingBuilder {
    return new FloatingBuilder();
  }
}
